export default class DownloadCreator {
  static download(filename, string) {
    const blob = new Blob([string])
    const data = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = data
    link.download = filename
    link.click()
    link.remove()
  }
}